import { t } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  returnTypeConditionFromModel,
  validateReturnTypeCondition,
  type ReturnTypeState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const RETURN_TYPE = (
  Details: React.ComponentType<ConditionTypeDetailsProps<ReturnTypeState>>,
): ConditionType<ReturnTypeState, Condition.ReturnType> => ({
  name: CONDITION_NAMES[Condition.RETURN_TYPE],
  description(state) {
    if (state.returnTypes.length === 0) {
      return t("No return types selected");
    }
    const types = state.returnTypes
      .map((type) => type.charAt(0).toUpperCase() + type.slice(1))
      .join(", ");
    return t("Return type is {{types}}", { types });
  },
  Details(props: ConditionTypeDetailsProps<ReturnTypeState>) {
    return React.createElement(Details, props);
  },
  empty: { returnTypes: [] },
  fromModel(model) {
    return returnTypeConditionFromModel(model);
  },
  toModel(state) {
    return { type: Condition.RETURN_TYPE, returnTypes: state.returnTypes };
  },
  valid(state) {
    return validateReturnTypeCondition(state).valid;
  },
});
